module.exports = __webpack_public_path__ + "static/media/language-solid.8252db28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/language-solid.svg
// module id = 225
// module chunks = 0